// extracted by mini-css-extract-plugin
module.exports = {"heading":"productView_heading__y-vi1","para":"productView_para__2injm","image":"productView_image__3wFVu","card":"productView_card__3h-XM","button":"productView_button__EJRKu"};